module.exports = __webpack_public_path__ + "img/download-app-banner-mobile.82c86d9c.png";